var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 45.455,
    viewBox: "0 0 50 45.455",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "logo (1)"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 8",
    d: "M10.924 34.131c1.3-2.034 3.34-2.037 5.983-.925a23.726 23.726 0 0 0 8.421 2.086c4.092 0 5.986-1.669 5.986-3.482 0-2.25-2.425-3.265-4.471-3.991-2.955-1.088-7.48-1.955-10.916-3.338a20.3 20.3 0 0 1-4.986-2.8 12.622 12.622 0 0 1-4.05-9.707A13.816 13.816 0 0 1 13.676.188c.157-.1.23-.165.23-.189A24.219 24.219 0 0 0 0 21.682a23.751 23.751 0 0 0 7.722 17.454l3.2-5",
    style: {
      fill: "#00a8e1",
      fillRule: "evenodd"
    },
    transform: "translate(0 .001)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 9",
    d: "m83.288 13.647-3.173 4.968c-1.3 2.038-3.34 2.041-5.983.927a23.7 23.7 0 0 0-8.421-2.091c-4.092 0-5.986 1.673-5.986 3.49 0 2.254 2.425 3.272 4.471 4 2.955 1.091 7.48 1.959 10.916 3.344a20.308 20.308 0 0 1 4.986 2.8 12.659 12.659 0 0 1 4.05 9.726 13.877 13.877 0 0 1-6.94 11.909l-.07.046a24.262 24.262 0 0 0 13.819-21.68 23.813 23.813 0 0 0-7.67-17.439M89.619 53h.342c.226 0 .313-.077.313-.2 0-.147-.109-.2-.328-.2h-.327zm.641.209.364.664H90.3l-.327-.622h-.35v.622h-.3v-1.55h.633c.386 0 .626.182.626.462a.422.422 0 0 1-.32.425zm.954-.09a1.3 1.3 0 1 0-1.3 1.264 1.272 1.272 0 0 0 1.3-1.264zm.277 0a1.578 1.578 0 1 1-1.573-1.51 1.546 1.546 0 0 1 1.573 1.51z",
    transform: "translate(-41.49 -9.18)",
    style: {
      fill: "#00a8e1",
      fillRule: "evenodd"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.4e804a82de700863076a12c9804d6eb1.svg";
export { ForwardRef as ReactComponent };